import React from "react";
import {useForwardingBatchProvider} from "../../../Providers/ForwardingBatchProvider";
import {RenderBatchSectionType} from "../../../Types/ForwardingBatchTypes";

const BatchNotes = (props: RenderBatchSectionType) => {
    const { currentBatchData, UpdateNotes } = useForwardingBatchProvider();

    if(props.complete) {
        return <BatchNotesComplete {...props} />
    }

    return (
        <div>
            <h5 className={'mb-xs'}>{`Step ${props.sectionIndex}: ${props.section.name}`} {!props.complete && !props.readOnly && props.section.isOptional ?
                <span className="fade">(Optional)</span> : ''}</h5>

            <p>If you'd like to include any notes to the mail-room, please add them in the field below.</p>

            <div className={'card p-md'}>
                <textarea
                    rows={6}
                    defaultValue={currentBatchData?.notes}
                    onBlur={(e) => UpdateNotes(e.currentTarget.value)}
                    disabled={props.readOnly}
                />
            </div>
        </div>
    )
}

const BatchNotesComplete = (props: RenderBatchSectionType) => {
    const { currentBatchData} = useForwardingBatchProvider();

    if(!currentBatchData?.notes) return <></>;

    return (
        <div>
            <h5 className={'mb-xs'}>{props.section.name}</h5>

            <div className={'card p-md'}>
                <p>{currentBatchData?.notes}</p>
            </div>
        </div>
    )
}

export {BatchNotes}
